"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageActionTray = void 0;
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var SelectAllCheckbox_1 = __importDefault(require("Dashboard/ActionTray/SelectAllCheckbox"));
var Checkbox_1 = require("Dashboard/ActionTray/Checkbox");
var BASE_CLASS = "image-library-action-tray";
var ImageActionTray = (function (_super) {
    __extends(ImageActionTray, _super);
    function ImageActionTray(props) {
        return _super.call(this, props) || this;
    }
    ImageActionTray.prototype.render = function () {
        var _a = this.props, numSelectedImages = _a.numSelectedImages, onDelete = _a.onDelete, onSelectAllToggle = _a.onSelectAllToggle;
        return (react_1.default.createElement("div", { className: "".concat(BASE_CLASS) },
            react_1.default.createElement("div", { className: "".concat(BASE_CLASS, "__left") },
                react_1.default.createElement(SelectAllCheckbox_1.default, { resourceLabel: "image", toggleClick: onSelectAllToggle, selectionState: this.checkboxState, numSelectedProjects: numSelectedImages })),
            react_1.default.createElement("div", { className: "".concat(BASE_CLASS, "__right") }, numSelectedImages > 0 && (react_1.default.createElement(kaleidoscope_1.IconButton, { isDestructive: true, "aria-label": "Delete", type: kaleidoscope_1.ButtonType.Tertiary, icon: react_1.default.createElement(icons_1.Delete, null), onClick: onDelete, buttonState: kaleidoscope_1.ButtonState.Idle, size: kaleidoscope_1.ButtonSize.Small, tooltip: {
                    content: "Delete",
                    position: kaleidoscope_1.TooltipPosition.Bottom,
                } })))));
    };
    Object.defineProperty(ImageActionTray.prototype, "checkboxState", {
        get: function () {
            var _a = this.props, numSelectedImages = _a.numSelectedImages, numLoadedImages = _a.numLoadedImages;
            if (numSelectedImages === 0) {
                return Checkbox_1.CheckboxState.None;
            }
            else {
                return numSelectedImages < numLoadedImages ? Checkbox_1.CheckboxState.Some : Checkbox_1.CheckboxState.All;
            }
        },
        enumerable: false,
        configurable: true
    });
    ImageActionTray = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], ImageActionTray);
    return ImageActionTray;
}(react_1.default.Component));
exports.ImageActionTray = ImageActionTray;
